import { RouteConfig } from 'vue-router'

const chat: Array<RouteConfig> = [
  {
    path: ':id/chat/public',
    name: 'chat.public',
    component: () =>
      import(/* webpackChunkName: "builder" */ '@/views/builder/BuilderChatCreate.vue'),
  },
  {
    path: ':id/chat',
    component: () =>
      import(/* webpackChunkName: "builder" */ '@/views/builder/chat/BuilderChat.vue'),
    children: [
      {
        path: 'public_avatar',
        name: 'chat.public_avatar',
        component: () =>
          import(
            /* webpackChunkName: "builder" */ '@/views/builder/chat/BuilderChatPublicAvatar.vue'
          ),
      },
      {
        path: 'personal',
        name: 'chat.personal',
        component: () =>
          import(/* webpackChunkName: "builder" */ '@/views/builder/chat/BuilderChatPersonal.vue'),
      },
      {
        path: 'personal_avatar',
        name: 'chat.personal_avatar',
        component: () =>
          import(
            /* webpackChunkName: "builder" */ '@/views/builder/chat/BuilderChatPersonalAvatar.vue'
          ),
      },
      {
        path: 'private',
        name: 'chat.private',
        component: () =>
          import(/* webpackChunkName: "builder" */ '@/views/builder/chat/BuilderChatPrivate.vue'),
      },
      {
        path: 'private_avatar',
        name: 'chat.private_avatar',
        component: () =>
          import(/* webpackChunkName: "builder" */ '@/views/builder/chat/BuilderChatPrivateAvatar.vue'),
      },
      {
        path: 'private_settings',
        name: 'chat.private_settings',
        component: () =>
          import(
            /* webpackChunkName: "builder" */ '@/views/builder/chat/BuilderChatPrivateSettings.vue'
          ),
      },
      {
        path: 'capabilities',
        name: 'chat.capabilities',
        component: () =>
          import(
            /* webpackChunkName: "builder" */ '@/views/builder/chat/BuilderChatCapabilities.vue'
          ),
      },
      {
        path: 'delete_channels',
        name: 'chat.delete_channels',
        component: () =>
          import(
            /* webpackChunkName: "builder" */ '@/views/builder/chat/BuilderChatDeleteChannels.vue'
          ),
      },
      {
        path: 'create_channels',
        name: 'chat.create_channels',
        component: () =>
          import(
            /* webpackChunkName: "builder" */ '@/views/builder/chat/BuilderChatCreateChannels.vue'
          ),
      },
    ],
  },
]

export default chat
